import React, { useContext, useMemo } from "react";
import classes from "../../indenttrack.module.css";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const ViewConsignmentDetails = ({ indentDetails, data }) => {
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const safeText = (v) => {
    if (v === null || v === undefined) return "--";
    const s = String(v).trim();
    return s.length ? s : "--";
  };

  const safeUpper = (v) => safeText(v).toUpperCase();

  const consignor =
    (indentDetails?.indentDetails?.lr_details[0]?.consignor_details ||
      data?.consignor_details) ??
    {};
  const consignee =
    (indentDetails?.indentDetails?.lr_details[0]?.consignee_details ||
      data?.consignee_details) ??
    {};
  const consignmentDetails = Array.isArray(
    indentDetails?.indentDetails?.lr_details?.[0]?.consignment_details
  )
    ? indentDetails.indentDetails.lr_details[0].consignment_details
    : Array.isArray(data?.consignment_details)
    ? data.consignment_details
    : [];

  const hasConsignment = consignmentDetails.length > 0;

  const customColumns = useMemo(() => {
    const cols = [];
    for (let i = 0; i < consignmentDetails.length; i++) {
      const c = consignmentDetails[i];
      const orders = Array.isArray(c?.orders_list) ? c.orders_list : [];
      for (let j = 0; j < orders.length; j++) {
        const o = orders[j];
        const fields = Array.isArray(o?.custom_consignment_fields)
          ? o.custom_consignment_fields
          : [];
        for (let k = 0; k < fields.length; k++) {
          const name = fields[k]?.name;
          if (name && !cols.includes(name)) cols.push(name);
        }
      }
    }
    return cols;
  }, [consignmentDetails]);

  const getCustomFieldValue = (order, fieldName) => {
    const list = Array.isArray(order?.custom_consignment_fields)
      ? order.custom_consignment_fields
      : [];
    const found = list.find((x) => x?.name === fieldName);
    return safeText(found?.value);
  };

  const salesInvoiceCount = useMemo(() => {
    let count = 0;
    for (let i = 0; i < consignmentDetails.length; i++) {
      const orders = Array.isArray(consignmentDetails[i]?.orders_list)
        ? consignmentDetails[i].orders_list
        : [];
      count += orders.length;
    }
    return count;
  }, [consignmentDetails]);

  const currency =
    companySettingData?.default_currency?.default_currency?.cc ?? "INR";

  const ValueBox = ({ value }) => (
    <input type="text" value={value === "--" ? "" : value} disabled={true} />
  );

  // const isDataEmpty = !data || !indentDetails?.indentDetails?.lr_details[0] || (Object.keys(data).length === 0) || (Object.keys(indentDetails?.indentDetails?.lr_details[0]).length===0)
  // if (isDataEmpty) {
  //   return (
  //     <div className="text-center p-4">
  //       <div className="border rounded bg-light py-5">
  //         <div className="fw-semibold">No consignment details available.</div>
  //         <div className="small text-muted">Add from Indent Tracking → View.</div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="text-center">
      {/* Consignor */}
      <div className="row text-left">
        <div className={`col-12 ${classes["text-color-light"]}`}>
          Consignor Details
        </div>

        <div className="col-md-4 mb-2">
          <span>Customer Name</span>
          <ValueBox
            value={safeText(
              consignor?.customer_name || indentDetails?.origin?.customer_name || indentDetails?.trackData?.indent_details?.origin?.customer_name
            )}
          />
        </div>

        <div className="col-md-4 mb-2">
          <span>Address</span>
          <ValueBox
            value={safeText(
              consignor?.addressLine1 || indentDetails?.origin?.addressLine1 || indentDetails?.trackData?.indent_details?.origin?.addressLine1
            )}
          />
        </div>

        <div className="col-md-4 mb-2">
          <span>GST No.</span>
          <ValueBox
            value={safeUpper(
              consignor?.gst_no || indentDetails?.origin?.gst_no || indentDetails?.trackData?.indent_details?.origin?.gst_no
            )}
          />
        </div>
      </div>

      {/* Consignee */}
      <div className="row text-left">
        <div className={`col-12 ${classes["text-color-light"]}`}>
          Consignee Details
        </div>

        <div className="col-md-4 mb-2">
          <span>Customer Name</span>
          <ValueBox
            value={safeText(
              consignee?.customer_name ||
                indentDetails?.destination?.customer_name || indentDetails?.trackData?.indent_details?.destination?.customer_name
            )}
          />
        </div>

        <div className="col-md-4 mb-2">
          <span>Address</span>
          <ValueBox
            value={safeText(
              consignee?.addressLine1 ||
                indentDetails?.destination?.addressLine1 || indentDetails?.trackData?.indent_details?.destination?.addressLine1
            )}
          />
        </div>

        <div className="col-md-4 mb-2">
          <span>GST No.</span>
          <ValueBox
            value={safeUpper(
              consignee?.gst_no || indentDetails?.destination?.gst_no || indentDetails?.trackData?.indent_details?.destination?.gst_no
            )}
          />
        </div>
      </div>

      {/* Table / Empty State */}
      <div className={`row ${classes["table-alignment"]} m-2`}>
        {hasConsignment ? (
          <table className={`${classes["table-width"]} table table-borderless`}>
            <thead>
              <tr
                style={{ fontSize: "14px" }}
                className={classes["row-header"]}
              >
                <th
                  className={`${classes["sticky-th"]} ${classes["document-input"]}`}
                  style={{ minWidth: "120px" }}
                >
                  Document No.
                </th>
                <th
                  className={`${classes["sticky-th"]} ${classes["material-desc-input"]}`}
                  style={{ minWidth: "220px" }}
                >
                  Material Description
                </th>
                <th
                  className={`${classes["sticky-th"]} ${classes["material-code-input"]}`}
                  style={{ minWidth: "140px" }}
                >
                  Material Code
                </th>
                <th
                  className={`${classes["sticky-th"]} ${classes["material-code-input"]}`}
                  style={{ minWidth: "110px" }}
                >
                  Quantity
                </th>
                <th
                  className={`${classes["sticky-th"]} ${classes["weight-input"]}`}
                  style={{ minWidth: "160px" }}
                >
                  Unit Weight(in KG)
                </th>
                <th
                  className={`${classes["sticky-th"]} ${classes["value-input"]}`}
                  style={{ minWidth: "160px" }}
                >
                  Sales Value ({currency})
                </th>

                {customColumns.map((name) => (
                  <th
                    key={name}
                    className={classes["sticky-th"]}
                    style={{ minWidth: "160px", textAlign: "center" }}
                  >
                    {name}
                    <br />
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: "normal",
                        color: "#555",
                      }}
                    >
                      (User Defined)
                    </span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className={classes["scrollable-body"]}>
              {consignmentDetails.map((consignment, cIndex) => {
                const orders = Array.isArray(consignment?.orders_list)
                  ? consignment.orders_list
                  : [];
                if (orders.length === 0) return null;

                return (
                  <React.Fragment key={cIndex}>
                    {orders.map((order, oIndex) => (
                      <tr key={`${cIndex}-${oIndex}`}>
                        <td className={classes["document-input"]}>
                          {safeText(consignment?.invoice_no)}
                        </td>
                        <td className={classes["material-desc-input"]}>
                          {safeText(order?.material_name)}
                        </td>
                        <td className={classes["material-code-input"]}>
                          {safeText(order?.material_code)}
                        </td>
                        <td className={classes["material-code-input"]}>
                          {safeText(order?.quantity)}
                        </td>
                        <td className={classes["weight-input"]}>
                          {safeText(order?.material_weight)}
                        </td>
                        <td className={classes["document-input"]}>
                          {safeText(order?.invoice_value)}
                        </td>

                        {customColumns.map((col) => (
                          <td
                            key={`${cIndex}-${oIndex}-${col}`}
                            style={{ textAlign: "center" }}
                          >
                            {getCustomFieldValue(order, col)}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="col-12">
            <div className="border rounded bg-light py-5 text-center">
              <div className="fw-semibold">
                No consignment details available.
              </div>
              <div className="small text-muted">
                Add from Indent Tracking → View.
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="d-flex flex-column align-items-end px-2 pb-2">
        <div className="d-flex align-items-center gap-2">
          <div style={{ fontWeight: 700 }}># Sales Invoices:</div>
          <span className="badge bg-light text-dark border">
            {salesInvoiceCount}
          </span>
        </div>
        <div className="small text-muted mt-1">
          To add details, go to Indent Tracking → View.
        </div>
      </div>
    </div>
  );
};

export default ViewConsignmentDetails;
